import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces/index';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    outerwrapper: {
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      pointerEvents: 'none',
      [breakpoints.down(ScreenSizes.TabletVertical)]: {
        display: 'none',
      },
    },
    innerwrapper: {
      position: 'relative',
      display: 'flex',
      // Spans the whole free zone left of the content card: the negative margin
      // cancels the 30px page padding, so only the card width is subtracted
      // (730px card - 30px padding). Keeping the zone exactly as wide as the
      // free space leaves the most room for the preview before it gets clipped.
      marginLeft: '-30px',
      width: 'calc(100% - 700px)',
      justifyContent: 'flex-start',
      height: '100%',
      // keeps the preview from spilling over the content card when the free
      // zone is narrower than the preview — only transparent margins get cut
      overflow: 'hidden',
      // the content card shrinks from 730px to 530px at this breakpoint
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 'calc(100% - 500px)',
      },
    },
  };
};
